export enum EntityType {
  DEAL = 1,
  COMPANY,
  PERSON,
  USER,
  LEAD,
  CONTRACT,
  PARTNER,
  PARTNER_CONTACT
}
